import { Box, Typography, Avatar, Card } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";

const testimonials = [
  {
    companyLogo: "/companyLogo2.png",
    title: "Quick and Hassle-Free Loan Approval!",
    description: (
      <>
        After struggling with unfavourable loans following the impact of COVID-19, we turned to Mr. Amit Ruhela and his team for assistance. Their deep financial expertise, combined with years of experience working with businesses in similar situations, proved invaluable. Mr. Ruhela not only approached our challenges with empathy and understanding, but also provided sound, strategic advice that was tailored to our needs. His team's strong rapport with multiple banks played a pivotal role in securing a deal that exceeded our expectations.
        <br /><br />
        Throughout the process, Mr. Ruhela and Team Dequitec were diligent, efficient, and worked tirelessly to ensure that every aspect was handled swiftly and professionally. I have no hesitation in recommending his services to anyone seeking new debt or looking to secure more favorable terms on existing loans. His dedication and expertise are unmatched.
      </>
    ),
    avatar: "/avtar1.png",
    name: "Ankit Bajaj",
    designation: "Bajaj Equipment Ltd, Delhi",
  },
  {
    companyLogo: "/companyLogo3.png",
    title: "Expert Guidance and Seamless Support",
    description:
    "I had an excellent experience working with Amit ji and Team Dequitec to secure a loan for my business. Their expertise and guidance were invaluable throughout the process.",
    avatar: "/avtar2.png",
    name: "Sanjeev Goel",
    designation: "Rainbow Enterprises, Noida",
  },
  {
    companyLogo: "/companyLogo1.png",
    title: "Always There for My Business",
    description:
      "Ankur ji and Team Dequitec always stand by me in any needs of my business and they helped me in every aspect of business either it's a finance or in any  bank service. I will recommend their services to all my friends and dear ones. Thanks a lot for your kind support.",
    avatar: "/avtar3.png",
    name: "Murtaza Chudiwala",
    designation: "Murtaza International, Delhi",
  },
];

const Testimonials = () => {
  return (
    <>
      <Box
        sx={{
          backgroundColor: "#EDF0FF",
          borderRadius: "20px",
          padding: { xs: 3, md: 6 },
          marginX: { xs: 2, md: 6, lg: 14 },
          boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
        }}
      >
        <Box display="flex" flexDirection={{ xs: "column", md: "row" }} gap={4}>
          {/* Left Side */}
          <Box flex={1} textAlign={{ xs: "center", md: "left" }}>
            {/* Centered Line & Title */}
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "left",
                gap: 2,
              }}
            >
              <Box
                sx={{
                  width: "50px",
                  height: "3px",
                  backgroundColor: "#004AAD",
                }}
              />
              <Typography
                variant="h6"
                sx={{ fontWeight: "bold", color: "#004AAD" }}
              >
                TESTIMONIALS
              </Typography>
            </Box>
            <Typography variant="h5" color="#333333" fontWeight="bold" mt={2}>
              Hear what our clients say
            </Typography>
            <Typography variant="body2" color="#555555" mt={2} maxWidth="600px">
              Customer feedback helps us improve and ensure the best service.
              Hear directly from those who’ve experienced our offerings and see
              why they trust us.
            </Typography>
            <Card
              sx={{
                backgroundColor: "#FFFFFF",
                padding: 4, // Increased padding for better spacing
                borderRadius: "10px",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                marginTop: 3,
              }}
            >
              <Box display="flex" alignItems="center" gap={2} mb={2}>
                <img
                  src={testimonials[0]?.companyLogo}
                  alt="Company Logo"
                  style={{ height: "20px" }}
                />
              </Box>
              <Typography variant="h7" fontWeight="bold" color="#333333">
                {testimonials[0].title}
              </Typography>
              <Typography variant="body2" color="#555555" mt={1} sx={{ textAlign: 'justify' }}>
                {testimonials[0].description}
              </Typography>
              <Box display="flex" alignItems="center" gap={2} mt={3}>
                <Avatar
                  src={testimonials[0].avatar}
                  alt={testimonials[0].name}
                  sx={{ width: 50, height: 50 }}
                />
                <Box>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "left",
                      gap: 2,
                    }}
                  >
                    <Box
                      sx={{
                        width: "15px",
                        height: "1px",
                        backgroundColor: "#004AAD",
                      }}
                    />
                    <Typography fontWeight="bold" color="#333333">
                      {testimonials[0].name}
                    </Typography>
                  </Box>
                  <Typography
                    variant="body2"
                    fontStyle="italic"
                    color="#777777"
                  >
                    {testimonials[0].designation}
                  </Typography>
                </Box>
              </Box>
            </Card>
          </Box>

          {/* Right Side - Two Cards */}
          <Box flex={1} display="flex" flexDirection="column" gap={4}>
            {testimonials.slice(1).map((testimonial, index) => (
              <Card
                key={index}
                sx={{
                  backgroundColor: "#FFFFFF",
                  padding: 4, // Increased padding for better spacing
                  borderRadius: "10px",
                  boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
                }}
              >
                <Box display="flex" alignItems="center" gap={2} mb={2}>
                  <img
                    src={testimonial?.companyLogo}
                    alt="Company Logo"
                    style={{ height: "20px" }}
                  />
                </Box>
                <Typography variant="h7" fontWeight="bold" color="#333333">
                  {testimonial?.title}
                </Typography>
                <Typography variant="body2" color="#555555" mt={1} sx={{ textAlign: 'justify' }}>
                  {testimonial?.description}
                </Typography>
                <Box display="flex" alignItems="center" gap={2} mt={3}>
                  <Avatar
                    src={testimonial?.avatar}
                    alt={testimonial?.name}
                    sx={{ width: 50, height: 50 }}
                  />
                  <Box>
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "left",
                        gap: 2,
                      }}
                    >
                      <Box
                        sx={{
                          width: "15px",
                          height: "1px",
                          backgroundColor: "#004AAD",
                        }}
                      />
                      <Typography fontWeight="bold" color="#333333">
                        {testimonial.name}
                      </Typography>
                    </Box>

                    <Typography
                      variant="body2"
                      fontStyle="italic"
                      color="#777777"
                    >
                      {testimonial.designation}
                    </Typography>
                  </Box>
                </Box>
              </Card>
            ))}
          </Box>
        </Box>
        
        <Box display="flex" justifyContent="flex-end" mt={3}>
          <RouterLink to="/testimonials" style={{ textDecoration: "none" }}>
            <Typography 
              color="#004AAD"
              sx={{ 
                fontWeight: "bold", 
                cursor: "pointer",
                fontSize: "14px",
                '&:hover': {
                  textDecoration: 'underline'
                }
              }}
            >
              View More &gt;&gt;
            </Typography>
          </RouterLink>
        </Box>
      </Box>
    </>
  );
};

export default Testimonials;
